export const enum DiffType {
	NoChange = "=",
	Insertion = "+",
	Deletion = "-",
}

export interface IDiffItem<T> {
	type: DiffType;
	value: T;
}

const defaultEqual = <T>(a: T, b: T) => a === b;

// tslint:disable-next-line
export function diff<T>(arr1: T[], arr2: T[], areEqual: (oldValue: T, newValue: T) => boolean = defaultEqual): Array<IDiffItem<T>> {
	// fill first row and first column with 0
	const matrix: number[][] = Array(arr1.length + 1);
	for (let index1 = 0; index1 <= arr1.length; index1++) {
		matrix[index1] = Array(arr2.length + 1);
		matrix[index1][0] = 0;
	}
	matrix[0].fill(0);

	// fill rest via dynamic programming
	for (let index2 = 1; index2 <= arr2.length; index2++) {
		for (let index1 = 1; index1 <= arr1.length; index1++) {
			if (areEqual(arr1[index1 - 1], arr2[index2 - 1])) {
				matrix[index1][index2] = matrix[index1 - 1][index2 - 1] + 1;
			} else {
				matrix[index1][index2] = Math.max(matrix[index1][index2 - 1], matrix[index1 - 1][index2]);
			}
		}
	}

	// generate diff
	{
		// tslint:disable-next-line
		let result: Array<IDiffItem<T>> = [];
		let index1 = arr1.length;
		let index2 = arr2.length;

		while (true) {
			if (index1 > 0 && index2 > 0 && areEqual(arr1[index1 - 1], arr2[index2 - 1])) {
				result.unshift({ type: DiffType.NoChange, value: arr1[index1 - 1] });
				index1--;
				index2--;
			} else if (index2 > 0 && (index1 === 0 || matrix[index1][index2 - 1] >= matrix[index1 - 1][index2])) {
				result.unshift({ type: DiffType.Insertion, value: arr2[index2 - 1] });
				index2--;
			} else if (index1 > 0 && (index2 === 0 || matrix[index1][index2 - 1] < matrix[index1 - 1][index2])) {
				result.unshift({ type: DiffType.Deletion, value: arr1[index1 - 1] });
				index1--;
			} else {
				break;
			}
		}

		return result;
	}
}